import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { TimeIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import Dialog from '../../../../components/Dialog';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.875rem 1.875rem 1.563rem 1.587rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  infoIcon: {
    color: '#0e70a5',
    width: '1.25rem',
    height: '1.25rem',
    marginBottom: '0.5rem',
    marginLeft: '0.3rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  InputBase: {
    height: '3.75rem',
    borderRadius: '0.225rem',
    border: 'solid 1px #cccccc',
    width: '100%',
    paddingLeft: '1rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  labelError: {
    color: '#f44336',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '6px 0.125rem 0 0.125rem',
    color: '#f44336',
    fontSize: 12,
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  verify: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
    padding: '0.825rem',
  },
  alert: {
    '& .MuiAlert-standardSuccess': {
      // minWidth: '10rem',
      padding: '0.2rem 1rem',
    },
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    height: '3.5rem',
    width: '100%',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  addIcon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
    marginRight: '0.6rem',
  },
  addBtn: {
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
    marginLeft: '1rem',
  },
}));

export default function CustomHourPopup({ closePop, open, dutyStartAt, dutyEndAt, confirmClick, itemIndex }) {
  const classes = useStyles();

  const msToTime = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const hourStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minuteStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${hourStr}:${minuteStr}`;
  };

  const [inputChatStartAt, setInputChatStartAt] = useState(
    dutyStartAt !== undefined && dutyStartAt !== null ? msToTime(dutyStartAt) : '-'
  );
  const [inputChatEndAt, setInputChatEndAt] = useState(
    dutyEndAt !== undefined && dutyEndAt !== null ? msToTime(dutyEndAt) : '-'
  );
  const [errorMsg, setErrorMsg] = useState(null);
  const [timeInvalid, setTimeInvalid] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(false);

  useEffect(() => {
    checkStartEndTime();
  }, [inputChatEndAt, inputChatStartAt]);

  useEffect(() => {
    if (errorMsg) {
      if (errorMsg.chatStartAt || errorMsg.chatEndAt) {
        setConfirmDisabled(true);
      } else {
        setConfirmDisabled(false);
      }
    } else {
      setConfirmDisabled(false);
    }
    if (timeInvalid) {
      setConfirmDisabled(true);
    }
  }, [errorMsg, timeInvalid]);

  const checkStartEndTime = () => {
    const chatStartEmptyError = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_EMPTY');
    const chatEndEmptyError = i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME_EMPTY');
    const chatEndThanError = i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME_GREATER');
    if (inputChatStartAt === 'Invalid date' || inputChatEndAt === 'Invalid date') {
      setTimeInvalid(true);
    } else {
      setTimeInvalid(false);
    }
    let chatStartMsg = null;
    let chatEndMsg = null;
    if (
      inputChatEndAt !== null &&
      inputChatEndAt !== '-' &&
      inputChatEndAt !== '' &&
      (inputChatStartAt === null || inputChatStartAt === '-' || inputChatStartAt === '')
    ) {
      chatStartMsg = chatStartEmptyError;
    }
    if (
      inputChatStartAt !== null &&
      inputChatStartAt !== '-' &&
      inputChatStartAt !== '' &&
      (inputChatEndAt === null || inputChatEndAt === '-' || inputChatEndAt === '')
    ) {
      chatEndMsg = chatEndEmptyError;
    }
    if (
      inputChatEndAt !== null &&
      inputChatEndAt !== '-' &&
      inputChatEndAt !== '' &&
      inputChatStartAt !== null &&
      inputChatStartAt !== '-' &&
      inputChatStartAt !== ''
    ) {
      if (moment(inputChatEndAt, 'HH:mm') <= moment(inputChatStartAt, 'HH:mm')) {
        if (inputChatEndAt === '00:00:00' || inputChatEndAt === '00:00') {
          setErrorMsg({ ...errorMsg, chatEndMsg: null });
        } else {
          chatEndMsg = chatEndThanError;
        }
      }
    }
    setErrorMsg({ ...errorMsg, chatEndAt: chatEndMsg, chatStartAt: chatStartMsg });
  };
  const handleSetTimeDialogConfirm = () => {
    if (
      (inputChatStartAt === null || inputChatStartAt === '-' || inputChatStartAt === '') &&
      (inputChatEndAt === null || inputChatEndAt === '-' || inputChatEndAt === '')
    ) {
      confirmClick(itemIndex, null, null);
      closePop();
    } else {
      const formatStartTime = moment(inputChatStartAt, 'HH:mm').format('HH:mm').split(':');
      const formatEndTime = moment(inputChatEndAt, 'HH:mm').format('HH:mm').split(':');
      const msStartTime =
        formatStartTime.length > 1 ? formatStartTime[0] * 3600 * 1000 + formatStartTime[1] * 60 * 1000 : 0;
      const msEndTime = formatEndTime.length > 1 ? formatEndTime[0] * 3600 * 1000 + formatEndTime[1] * 60 * 1000 : 0;
      const endTimeFormat = msEndTime === 0 ? 24 * 3600 * 1000 : msEndTime;
      confirmClick(itemIndex, msStartTime, endTimeFormat);
      closePop();
    }
  };

  return (
    <Dialog
      open={open}
      handleClose={closePop}
      handleCancel={closePop}
      handleConfirm={handleSetTimeDialogConfirm}
      title={i18n.t('DUTYASSIGN_STAFF_CUSTOMIZE_WORK_HOUR')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      cancelID="DutyAssign-Dialog-setHour-cancel"
      confirmID="DutyAssign-Dialog-setHour-confirm"
      closeID="DutyAssign-Dialog-setHour-close"
      disabled={confirmDisabled}
    >
      <Box display="flex" mb="1.875rem">
        <Box width="50%" mr="1.275rem">
          <Typography id="setup-work-hour-start-time" className={classes.label}>
            {i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME')}
          </Typography>
          <KeyboardTimePicker
            ampm={false}
            id="staff_chatStartAt"
            className={classes.keyboardTimeInput}
            keyboardIcon={<TimeIcon className={classes.timeIcon} />}
            inputVariant="outlined"
            InputAdornmentProps={{ position: 'end' }}
            variant="dialog"
            placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_START_TIME')}
            value={inputChatStartAt === '-' ? null : moment(inputChatStartAt, 'HH:mm')}
            onChange={(value) => {
              if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                setInputChatStartAt('-');
                return;
              }
              setInputChatStartAt(moment(value).format('HH:mm'));
            }}
            onBlur={() => {
              checkStartEndTime();
            }}
          />
          {errorMsg?.chatStartAt ? (
            <Typography id="setup-work-hour-start-time-error-message" className={classes.errorMsg}>
              {errorMsg.chatStartAt}
            </Typography>
          ) : (
            ''
          )}
        </Box>
        <Box width="50%">
          <Typography id="setup-work-hour-end-time" className={classes.label}>
            {i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME')}
          </Typography>
          <KeyboardTimePicker
            id="staff_chatEndAt"
            className={classes.keyboardTimeInput}
            keyboardIcon={<TimeIcon className={classes.timeIcon} />}
            inputVariant="outlined"
            InputAdornmentProps={{ position: 'end' }}
            ampm={false}
            variant="dialog"
            placeholder={i18n.t('DUTYASSIGN_TEAMDETAILS_END_TIME')}
            value={inputChatEndAt === '-' ? null : moment(inputChatEndAt, 'HH:mm')}
            onChange={(value) => {
              if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                setInputChatEndAt('-');
                return;
              }
              setInputChatEndAt(moment(value).format('HH:mm'));
            }}
            onBlur={() => {
              checkStartEndTime();
            }}
          />
          {errorMsg?.chatEndAt ? (
            <Typography id="setup-work-hour-end-time-error-message" className={classes.errorMsg}>
              {errorMsg.chatEndAt}
            </Typography>
          ) : (
            ''
          )}
        </Box>
      </Box>
    </Dialog>
  );
}
